export default __webpack_public_path__ + "static/media/aircare-banner-1.a233d5ae.jpg";